const common = {
  site_name: '伦理在线',
  site_tagline: '伦理学习与道德资源平台',
  nav_home: '首页',
  nav_categories: '分类浏览',
  nav_about: '关于我们',
  nav_articles: '文章列表',
  read_more: '阅读全文',
  back_to_home: '返回首页',
  scroll_to_top: '回到顶部',
  minutes_read: '分钟阅读',
  related_articles: '相关文章',
  all_articles: '全部文章',
  no_articles: '暂无文章',
  view_all: '查看全部',
  subscribe: '订阅资讯',
  subscribe_placeholder: '输入您的邮箱地址',
  subscribe_button: '订阅',
  copyright: '© 2025 伦理在线 版权所有',
  loading: '加载中...',
  error: '加载失败',
  retry: '重试',
};

export default common;